const details = {
    name: "PaperLess",
    enName: "shop",
    description: "PaperLess",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "شرکت توسعه و طراحی سایت باران",
        link: "https://barantm.com"
    }
}

export default details;
